import { post } from '@/util/auth'

import type { CreateBuyoutOfferPayload } from './types'

const IS_NEW_BACKEND_API = true
const API_ROUTE_BUYOUT_OFFERS = 'assets/buyout-offers'

export const createBuyoutOffer = async (payload: CreateBuyoutOfferPayload): Promise<void> => {
  await post(API_ROUTE_BUYOUT_OFFERS, payload, IS_NEW_BACKEND_API)
}
